import React, { useEffect, useMemo, useState } from "react";
import "./NurtureCampaignEmailReachOut.css";
import FeedbackSuggestions from "./FeedbackSuggestions";
import NurtureEmailComp from "./NurtureEmailComp";
import { useUser } from "../../../../../../context/UserContext";
import {
  editTemplate,
  finalSubmitCampaign,
  updateTemplate,
} from "../../../../../../services/iqApiV2";
import * as FeatherIcon from "react-feather";
import SimpleThemedButton from "../../../../genericComponents/simpleTextField/SimpleThemedButton";
import { formatDate, formatDateToYMD } from "../../../../../../utilities/dateUtils";
import ReachOutProfileComp from "./ReachOutProfileComp";
import StatusIndicator from "../../../../genericComponents/resizeableTable/StatusIndicator";
import NurtureReplyCard from "./NurtureReplyCard";
import RenderHtmlFormattedText from "../../../../../HtmlElements/RenderHtmlFormattedText";
import DynamicRecursiveComp from "../../../../../../utilities/DynamicRecursiveComp";
import { useBanner } from "../../../../../../context/BannerContext";
import GenericBanner from "../../../../genericComponents/uiElements/GenericBanner";
import EmailTiptapEditor from "./EmailTiptapEditor";
import { useAuthorizedUser } from "../../../../../../context/AuthorizedUserContext";
import WarningForNurture from "../WarningForNurture";
import WarningFadedRed from "../WarningFadedRed";

function formatDateLocal(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month?.length < 2) month = "0" + month;
  if (day?.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

function MyNode({ item }) {
  // console.log("MyNode item", item);
  return (
    <NurtureReplyCard
      date={item?.recievedDate}
      sender={item?.sender}
      email={
        <RenderHtmlFormattedText
          htmlContent={item.bodycontent}
          text_div_class="rt-body"
        />
      }
    />
  );
}

const NurtureCampaignEmailReachOut = ({ content }) => {
  const {
    currentCampDetails = {},
    stepDispatch,
    stepId,
    setCurrentStepIndex,
    _id,
    skipReview = false,
    sideCardCloseFunc,
    templates,
    emails,
    setEmails,
    isCampaignActive,
  } = content;
   const { isAuthorized, isAuthLoading } = useAuthorizedUser();
  const showBanner = useBanner();
  const campaignID = currentCampDetails?.campaignId;

  const [localEmails, setLocalEmails] = useState([]);
  // const [allEmails, setAllEmails] = useState([]);
  const [finalReview, setFinalReview] = useState(false);
  const [enableNextBtn, setEnableNextBtn] = useState(false);

  useEffect(() => {
    // normalize & guard helpers
    const isGenerating = (s) =>
      typeof s === "string" && s.trim().toLowerCase() === "generating...";
    const nonEmpty = (s) => typeof s === "string" && s.trim().length > 0;

    const complete =
      Array.isArray(emails) &&
      emails.length > 0 &&
      emails.every(
        (contact) =>
          Array.isArray(contact?.templates) &&
          contact.templates.length > 0 &&
          contact.templates.every(
            (tpl) =>
              nonEmpty(tpl?.subject) &&
              nonEmpty(tpl?.bodycontent) &&
              !isGenerating(tpl.subject) &&
              !isGenerating(tpl.bodycontent)
          )
      );

    setEnableNextBtn(Boolean(complete));
  }, [emails, setEnableNextBtn]);

  useEffect(() => {
    setLocalEmails(templates);
  }, [templates]);

  const [selectedEmail, setSelectedEmail] = useState(null);
  const [profileViewed, setProfileViewed] = useState(true);

  const [loading, setLoading] = useState(false);
  const [prompt, setPrompt] = useState("");
  const [emailUpdating, setEmailUpdating] = useState(false);
  // const [submitting,setSubmitting]=useState(false)
  const [templateId, setTemplateId] = useState(null);
  const [templateDate, setTemplateDate] = useState(new Date());

  const { user } = useUser();

  const startDate = currentCampDetails?.startDate
    ? new Date(currentCampDetails.startDate)
    : null;
    console.log("deep001",currentCampDetails?.startDate)
  const dateFrequency = Number(currentCampDetails?.daysFrequency) || 0;

  const handleUpdateEmail = async (promptData) => {
    setEmailUpdating(true);
    try {
      const resp = await editTemplate(
        user?.company_name,
        currentCampDetails.account,
        localEmails?.[selectedEmail]?.subject || "",
        localEmails?.[selectedEmail]?.bodycontent || "",
        promptData,
        campaignID,
        _id
      );

      if (resp?.success === 200 && resp?.message && templateId) {
        updateEmail(selectedEmail, {
          subject: resp.message.subject,
          bodycontent: resp.message.email,
        });
        // debugger

        // await updateTemplate(
        //   templateId,
        //   resp.message.subject,
        //   resp.message.email,
        //   templateDate
        // );
      }
    } catch (err) {
      console.error("Update email failed:", err);
    } finally {
      setEmailUpdating(false);
    }
  };

  const updateEmail = async (index, updatedFields) => {
    // commmented for beta
    // setLocalEmails((prev) => {
    //   const updated = [...prev];
    //   updated[index] = { ...updated[index], ...updatedFields };
    //   return updated;
    // });
   

    setEmails((prev) => {
      const updated = prev.map((each) => {
        // if `each.templates` is an array
        if (Array.isArray(each?.templates)) {
          const newTemplates = each.templates.map((item) => {
            if (item?._id === templateId) {
              // update fields here
              return {
                ...item,
                subject: updatedFields?.subject ?? item.subject,
                bodycontent: updatedFields?.bodycontent ?? item.bodycontent,
              };
            }
            return item;
          });

          return { ...each, templates: newTemplates };
        }
        return each;
      });

      // console.log("updated for templateId", templateId);
      return updated;
    });

    // 3) Persist to backend (adjust args as your API expects)
    await updateTemplate(
      templateId,
      updatedFields?.subject,
      updatedFields?.bodycontent,
      templateDate
    );
  };

  // const addEmptyEmail = () => {
  //   const newIndex = localEmails?.length;
  //   const d = new Date(startDate);
  //   d.setDate(d.getDate() + newIndex * dateFrequency);
  //   const newEmail = {
  //     subject: "",
  //     bodycontent: "",
  //     date_to_send: formatDateLocal(d),
  //   };
  //   setLocalEmails((prev) => [...prev, newEmail]);
  //   setSelectedEmail(newIndex);
  // };
    const [editing, setEditing] = useState(false); 

  const removeEmail = (indexToRemove) => {
    setLocalEmails((prev) => {
      const updated = prev.filter((_, i) => i !== indexToRemove);
      return updated?.map((email, i) => ({
        ...email,
        date_to_send: formatDateLocal(
          new Date(startDate.getTime() + i * dateFrequency * 86400000)
        ),
      }));
    });
    setEditing(false)
    setSelectedEmail(0);
  };

  const handleAddTemplates = async (campaignId, emailsList) => {
    try {
      stepDispatch({ type: "MARK_COMPLETED", payload: stepId });
      setCurrentStepIndex((prev) => prev + 1);
    } catch (error) {}
  };

  const chipDates = useMemo(() => {
    return localEmails?.map((_, i) => {
      const d = new Date(_?.date_to_send || startDate);
      d.setDate(d.getDate());
      return formatDateLocal(d);
    });
  }, [startDate, dateFrequency, localEmails?.length]);

  console.log("deep1",startDate,formatDateToYMD(new Date(startDate)),formatDateToYMD(new Date()))

  return (
    <div className="nce-reachout-container">
      {loading ? (
        <div className="nce-loading-wrapper">
          <div className="nce-loading-spinner" />
          <div className="nce-loading-text">Generating Emails...</div>
        </div>
      ) : (
        <div className={`nce-reachout-container-mails ${
                      emailUpdating || emails?.length == 0 ? "blurred" : ""
                    }`}>
          <div className="nce-chip-group">
            {localEmails?.length === 0 ? (
              <div className="nce-empty">No localEmails generated yet.</div>
            ) : (
              <>
                {
                  <button
                    className={`nce-chip ${
                      profileViewed ? "nce-chip-active" : ""
                    }`}
                    onClick={() => {
                      setProfileViewed(true);
                      setEditing(false)
                      setSelectedEmail(null);
                    }}
                    type="button"
                  >
                    Research
                  </button>
                }
                {localEmails?.map((eachEmail, i) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "0.3rem",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <button
                      key={i}
                      className={`nce-chip ${
                        selectedEmail === i ? "nce-chip-active" : ""
                      }`}
                      onClick={() => {
                        setProfileViewed(false);
                        setEditing(false)
                        setSelectedEmail(i);
                        setTemplateDate(chipDates[i]);
                      }}
                      type="button"
                    >
                      {`Email - ${
                        chipDates?.[i]
                          ? formatDate(chipDates[i], {
                              short: true,
                              hideYear: true,
                            })
                          : "—"
                      }`}
                    </button>
                 {(() => {
                  const { sent, isOpened, isReplied,isBounced } = eachEmail || {};
                  let status = "Scheduled";
                  let className = "scheduled-chip";

                  if (isReplied) {
                    status = "Replied";
                    className = "replied-chip";
                  } else if (isOpened) {
                    status = "Opened";
                    className = "opened-chip";
                  } else if (sent) {
                    status = "Sent";
                    className = "sent-chip";
                  }else if(isBounced)
                    {
                    status = "Bounced";
                    className = "bounced-chip";
                    }

                  return (
                    <span className={`nce-chip-label ${className}`}>
                      {status}
                    </span>
                  );
                })()}
                  </div>
                ))}
              </>
            )}

          </div>

          {profileViewed ? (
            <div
              className={`nce-email-inner-wrapper ${
                !templates ? "blurred" : ""
              }`}
            >
              <ReachOutProfileComp content={content} />
            </div>
          ) : (
            <>
              <div className="nce-email-comp-wrapper">
                <div
                  className="nce-email-inner-wrapper-wrapper"
                  style={{ position: "relative" }}
                >
                  <div
                    className="nce-email-inner-wrapper"
                  >
                    {}
                    {localEmails?.[selectedEmail] ? (
                      <EmailTiptapEditor
                        key={localEmails?.[selectedEmail]?._id}
                        email={localEmails?.[selectedEmail]}
                        showBanner={showBanner}
                        onUpdate={updateEmail}
                        onRemove={removeEmail}
                        setTemplateId={setTemplateId}
                        allowEditing={!localEmails?.[selectedEmail]?.sent}
                        editing={editing} setEditing={setEditing}
                      />
                    ) : (
                      <div className="nce-empty">
                        Select an email to preview.
                      </div>
                    )}
                  </div>

                  {emailUpdating && (
                    <div className="nce-email-blur-overlay">
                      <div className="nce-loading-content">
                        <div className="nce-spinner" />
                        <p className="nce-loading-text">
                          Sales Play is thinking...
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {!localEmails?.[selectedEmail]?.sent && (
                <FeedbackSuggestions
                  prompt={prompt}
                  setPrompt={setPrompt}
                  handleUpdateEmail={handleUpdateEmail}
                  btnDisabled={emailUpdating}
                />
              )}
              {localEmails?.[selectedEmail]?.sent &&
              localEmails?.[selectedEmail]?.replies?.length>0 ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center", // ensures the connector is centered
                    }}
                  >
                    {" "}
                    <div
                      style={{
                        width: "2px",
                        height: "2rem",
                        borderLeft: "2px dotted #999",
                      }}
                    />
                  </div>
                  <DynamicRecursiveComp
                    data={localEmails?.[selectedEmail]?.replies}
                    ItemComp={MyNode}
                    repliesKey="replies"
                    collapsible={true}
                    initiallyCollapsed={false}
                    getKey={(item, idx, path) =>
                      item._id ||
                      `${item.sub}-${item.date}-${path.join("-")}-${idx}`
                    }
                  />
                </>
              ) : null}
            </>
          )}
         {emailUpdating || emails?.length > 0 && <div
            style={{
              position: "fixed",
              width: "100%",

              zindex: "1000",
              borderTop: "1px solid #E2E8F0",
              right: "0rem",
              bottom: "0rem",
              padding: "0.5rem",

              backgroundColor: "#F2F6FB",
              display: "flex",
              justifyContent: "flex-end",
              alignItems:"center",
              gap:"1rem"
            }}
          >
            {!isAuthorized && <><WarningFadedRed text={"You are not authorized to start nurture"}/></>}
 


            {isCampaignActive ? (
              <div style={{ padding: "0.3rem" }}>
                <StatusIndicator text="Auto Nurture In Progress" />
              </div>
            ) : (
              <SimpleThemedButton
                buttonText={
                  <>
                    {" "}
                    {skipReview ? (
                      <>Start Nurture </>
                    ) : (
                      <>
                        {" "}
                        Review{" "}
                        <FeatherIcon.ArrowRight className="arrow_up_fbx" />
                      </>
                    )}
                  </>
                }
                btnDisabled={!enableNextBtn || (startDate &&
                formatDateToYMD(new Date(startDate)) <
                formatDateToYMD(new Date())) 
                || !isAuthorized
              }
                isLoading={false}
                onBtnClick={async () => {
                  if (skipReview) {
                    setFinalReview(true);
                  } else {
                    handleAddTemplates(
                      currentCampDetails?.campaignId,
                      localEmails
                    );
                  }
                }}
              />
            )}
          </div>}
          {finalReview && (
            <div className="alert-dialog-backdrop">
              <div className="alert-dialog">
                <h3 className="alert-title">Alert</h3>
                <p className="alert-message">
                  Emails will be sent to{" "}
                  <strong>
                    {emails?.length > 1
                      ? `${emails.length} contacts`
                      : emails?.[0]?.name || "0 contacts"}
                  </strong>
                </p>
                {formatDateToYMD(new Date(startDate))<formatDateToYMD(new Date())&&
                <p>
                      <GenericBanner type="error" message="Campaign Start Date cannot be less than today" />
                </p>}

                <div className="alert-actions">
                  <SimpleThemedButton
                    buttonText="Cancel"
                    variant="outline"
                    onBtnClick={() => setFinalReview(false)}
                  />
                  <SimpleThemedButton
                    loaderTxt="Starting"
                    buttonText="Start Nurture"
                    btnDisabled={!enableNextBtn || (startDate &&
                    formatDateToYMD(new Date(startDate)) <
                    formatDateToYMD(new Date()))}
                    onBtnClick={async (e) => {
                      const resp = await finalSubmitCampaign(
                        currentCampDetails?.campaignId
                      );

                      if (resp?.success) {
                        showBanner({
                          message: "Auto  Nurture Started",
                          title: "Alert",
                          type: "success",
                          duration: 5000,
                        });
                      }
                      sideCardCloseFunc(false);
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default NurtureCampaignEmailReachOut;
